import { render, staticRenderFns } from "./BicCard.vue?vue&type=template&id=d91b605c&scoped=true&"
import script from "./BicCard.vue?vue&type=script&lang=js&"
export * from "./BicCard.vue?vue&type=script&lang=js&"
import style0 from "./BicCard.vue?vue&type=style&index=0&id=d91b605c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d91b605c",
  null
  
)

export default component.exports